export default __webpack_public_path__ + "static/media/4.001f8392.jpg";